import { OrganizerType } from "../../../../../../shared/types/OrganizerTypes"

import type { MenuMeeting } from "../../../../../nonAdminUser/reports/home/weekMenuTypes"
import { AttendeeState, type MeetingAttendee, type MeetingDetailsOrder } from "../../meetings/meetingTypes"

// Adapts the drawer's meeting to the shape MeetingCardMenu expects. With `menuOnApi` the menu refetches the
// real orderAction/summary, so the placeholder summary here only satisfies the type.
export function toMenuMeeting(meetingData: MeetingDetailsOrder): MenuMeeting {
    const { meetingName, startDateTime, endDateTime } = meetingData.meetingDetails
    return {
        id: meetingData.id,
        uid: meetingData.uid,
        orderSummary: { participants: 0, hasCatering: false, hasBooking: false, hasAudioVideoEquipment: false },
        organizers: meetingData.organizers,
        meetingDetails: { meetingName, startDateTime, endDateTime },
    }
}

export function resolveMeetingHostId(meetingData?: MeetingDetailsOrder): number | undefined {
    const organizers = meetingData?.organizers ?? []
    const idForType = (type: OrganizerType) =>
        organizers.find((organizer) => organizer.organizerType === type && organizer.id > 0)?.id
    return (
        idForType(OrganizerType.RESPONSIBLE) ?? idForType(OrganizerType.ORGANIZER) ?? idForType(OrganizerType.CREATOR)
    )
}

// External guests from meetingDetails.attendees; fallback to the legacy top-level attendees position.
export function resolveExternalAttendees(meetingData?: MeetingDetailsOrder): MeetingAttendee[] {
    const fromDetails = meetingData?.meetingDetails.attendees ?? []
    if (fromDetails.length > 0) {
        return fromDetails
            .filter((attendee) => attendee.external === true)
            .map((attendee, index) => ({
                // index only keys the list locally when the API has no id
                id: attendee.id ?? index,
                name: attendee.name,
                companyName: attendee.company ?? "",
                isExternal: attendee.external ?? false,
                state: AttendeeState.EXPECTED,
            }))
    }

    return (meetingData?.attendees ?? []).filter((attendee) => attendee.isExternal)
}
